import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-right: 2px;
`;
